import { Pipe, PipeTransform, inject } from '@angular/core';
import { LanguageService } from './language.service';

@Pipe({
  name: 'lemTranslate',
  standalone: true,
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  private readonly language = inject(LanguageService);

  transform(value: string | null | undefined): string {
    // Lecture volontaire du signal afin que le pipe soit recalculé au changement de langue.
    this.language.language();
    return this.language.translate(value);
  }
}
